const CSR_CONSTANTS = {
    GET_CSR_DATA: 'v1/page/csr',
    GET_KLINIK_WAQAF_DATA: 'v1/page/klinik-wakaf-an-nur',
    GET_COVID19_BOOKLET_DATA: 'v1/page/kpjcovid19booklet'
};

export default CSR_CONSTANTS;
